import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'
import type { App } from 'vue'
import { createRouterGuards } from './guards'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL ?? ''),
  routes: routes,
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

export function setupRouter(app: App) {
  createRouterGuards(router)
  app.use(router)
}

export * from './route.constants'

export default router
